import { MuiButton } from '@/components/button/MuiButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, Typography } from '@mui/material';

type Props = {
  onBackToSearch: () => void;
};

export function HospitalMultiRequestNav({ onBackToSearch }: Props) {
  return (
    <Box
      sx={{
        py: 2,
        px: {
          sm: 5,
          lg: 15,
        },
        '@media (max-width: 800px)': {
          px: 2,
        },
      }}
    >
      <MuiButton
        variant="text"
        sx={{
          textDecoration: 'none',
          display: 'inline-flex',
          gap: 1,
          alignItems: 'center',
        }}
        onClick={onBackToSearch}
      >
        <ChevronLeftIcon
          fontSize="medium"
          sx={{
            pt: '3px',
          }}
        />
        <Typography variant="JP/Body/m/Medium/None">
          医療機関検索に戻る
        </Typography>
      </MuiButton>
    </Box>
  );
}
